import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { catchError, concatMap, EMPTY, finalize, from, mergeMap, Observable, tap } from 'rxjs';
import { StorageService } from '../../../core/services/storage/storage.service';
import { RdGameService } from '../games/rd-game';
import { GameInfoService } from '../games/game-info';
import { Router } from '@angular/router';

interface IPlayers {
    name: string,
    rq_id: number | null,
    gender_id: number,
    password?: string,
    is_starter: boolean,
    is_ready: boolean,
    is_newbie: boolean
}

interface IUField{
  position: number,
  userName: string,
  role_icon: string,
  is_starter: boolean,
}

interface IPlayer {
		"player_id": number,
		"name": string,
		"gender_name": string,
		"gender_icon": string,
		"gender_id": number | null,
		"is_starter": boolean,
		"is_ready": boolean,
		"is_newbie": boolean,
		"rq_id": number | null,
		"position": number | null,
		"dice_sum": number | null,
		"dice_value": number | null,
		"last_activity": number | null,
    "quest_list"?: Array<number>,
    "role_icon"?: string,
    "successesInGame"?: number,
		"created": number,
    [propName: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class PlayersService {

  http = inject(HttpClient);
  backend = inject(BackendService);
  storage = inject(StorageService);
  gameInfo = inject(GameInfoService);
  router = inject(Router);
  rdUse = inject(RdGameService);
  players: Array<any> = [];
  player: IPlayer;
  playerOnField: Array<IUField> = [];

  // variant #2
  playerOnFieldT: Array<IUField> = [];
  playerOnFieldQ: Array<IUField> = [];

  constructor() { }

  getInfoRoom(uuid: string){
    return this.http.get(`${this.backend.getApiUrl()}/rooms/${uuid}`);
  }

  createPlayerInRoom(room: any, started: boolean = false, password: string = ""){
    const uuid = room.uuid;
    const player: IPlayers = {
      name: "Player",
      rq_id: null,
      gender_id: 1,
      password: password,
      is_ready: false,
      is_newbie: false,
      is_starter: started
    }

    return this.http.post(`${this.backend.getApiUrl()}/rooms/${uuid}/players`, player).pipe(
      tap((data:any)=>{
        this.player = data.player;
        if(password.length){
          this.player.password = password;
        }
        this.savePlayerStorage();
      })
    );
  }

  getPlayersWithGame(uuid: string){
    return this.http.get(`${this.backend.getApiUrl()}/rooms/${uuid}/players`); 
  }

  savePlayer(user: IPlayer, uuid: string){
    
    this.player = {...user};
    this.savePlayerStorage();
    
    
    //// TODO поки відключеться
    return this.http.put(`${this.backend.getApiUrl()}/rooms/${uuid}/players/${this.player.player_id}`, this.player).pipe(
      tap( () =>  this.updateGame(uuid) )
    );
  }

  processDeletePlayersAndClosed(uuid: string, listIds: Array<number>){
    const source$ = from(listIds);
    const gameP = JSON.parse(sessionStorage.getItem("gamePeople") as string);
    
    let goUrl = (gameP === 'many')?'/step-two':'/step-one';
    source$.pipe(
      concatMap((id) => this.getRxJxExampleById(uuid, id)),
      tap((result) => console.info(result)),
      concatMap(() => this.http.put(`${this.backend.getApiUrl()}/rooms/${uuid}`, {stage_slug: "closed"})),
      finalize(() => this.router.navigate([goUrl]))
    ).subscribe();
  }

  processDeleteUserNotReady(uuid: string, listIds: Array<number>){
    const source$ = from(listIds);
    source$.pipe(
      mergeMap((id) => this.getRxJxExampleById(uuid, id)),
      tap((result) => console.info(result))
    ).subscribe();
  }

  getRxJxExampleById(uuid: string, player_id: number): Observable<any> {
    return this.http.delete<any>(`${this.backend.getApiUrl()}/rooms/${uuid}/players/${player_id}`)
        .pipe(
            catchError(err => {
                console.error(err)
                return EMPTY;
            })
        );
  }

  private updateGame(uuid: string){
    this.gameInfo.getGameInfo(uuid).subscribe((result: any) => {
      
      this.rdUse.updateGameByIdAvailable(uuid, result.room);
    });
  }

  savePlayerStorage(){
    this.storage.set('player', this.player);
  }

  getPlayerStorage(){
    this.player = JSON.parse(sessionStorage.getItem('player') as string);
  }

  detelePlayerById(uuid: string, player_id: number){
    this.deletePlayerWithRoom(uuid, player_id);
    this.removePlayerFromGame(player_id);
  }

  detelePlayerByIdFBRTDB(uuid: string, player_id: number){
    this.removePlayerFromGame(player_id);
  }

  detelePlayer(uuid: string){
   // this.deletePlayerWithRoom(uuid, this.player.player_id);
    if(this.player.is_starter){
      //this.rdUse.updateStatusGameFinished();
      setTimeout(()=>{
        this.deletePlayerWithRoom(uuid, this.player.player_id);
        this.rdUse.deleteGameById(uuid);
      },500)
    }else{
      
      this.deletePlayerWithRoom(uuid, this.player.player_id);
      this.removePlayerFromGame(this.player.player_id);
    }    
    this.storage.remove('player').subscribe();
  }

  detelePlayerStarter(uuid: string){
      setTimeout(()=>{
        this.rdUse.deleteGameById(uuid);
      },500)
    this.storage.remove('player').subscribe();
  }

  detelePlayerByPage(uuid: string){
     this.deletePlayerWithRoom(uuid, this.player.player_id);
    if(this.player.is_starter){
      //this.rdUse.updateStatusGameFinished();
      setTimeout(()=>{
        this.rdUse.deleteGameById(uuid);
      },500)
    }else{
      this.removePlayerFromGame(this.player.player_id);
    }    
    this.storage.remove('player').subscribe();
  }

  completionWork(uuid: string){
    if(this.player.is_starter){
        this.rdUse.deleteGameById(uuid);
    }else{
      this.removePlayerFromGame(this.player.player_id);
    }    
    this.storage.remove('player').subscribe();
  }

  detelePlayerForcedly(uuid: string){
   // this.deletePlayerWithRoom(uuid, this.player.player_id);    
    this.storage.remove('player').subscribe();
  }

  private deletePlayerWithRoom(uuid: string, player_id: number){
    this.http.delete(`${this.backend.getApiUrl()}/rooms/${uuid}/players/${player_id}`).subscribe({next: () => console.info(), error: (err) => console.error(`deletePlayerWithRoom - error events, ${err}`)});
  }

  private removePlayerFromGame(player_id: number): void{
    void this.rdUse.deleteUserwhithGame(player_id).catch((error: unknown) =>{
      console.error(`Failed to remove player ${player_id} from Firebase game state`, error);
    });
  }

  // TODO приблизна дія
  updateDice(dice: number){
    this.player = {...this.player, dice_value: dice, dice_sum: (this.player.dice_sum as number) + dice};
    this.player = this.uptetePosition(this.player);
    this.rdUse.updateDiceInGame(this.player);
    this.savePlayerStorage();
    this.setPlayerOnField();
  }

  uptetePosition(item:IPlayer){
    const fieldsLength: number = 24;
    if((item.dice_sum as number) > fieldsLength){
        const round = Math.floor((item.dice_sum as number) / fieldsLength);
        const newPosition = (item.dice_sum as number) - (fieldsLength * round);        
        item.dice_sum = (newPosition === 0) ? fieldsLength : newPosition;
    }
    return item;
  }


  changeFieldPlayers(){
    this.players.forEach(item =>{
      if(item.player_id === this.player.player_id){
        item.gender_name = "Default-Name";
        item.quest_list = []; 
        item.position =  0;
      }
    });
    
  }

  setPlayerOnField(){
    this.playerOnField = [];
    this.playerOnField.push({position: this.player.dice_sum as number, userName: this.player.name, role_icon: this.player.role_icon as string, is_starter: this.player.is_starter });
    if(this.players.length > 1){
      this.players.forEach((item: any)=>{
        if(this.player.player_id !== item.player_id){
          this.playerOnField.push({position: item.dice_sum as number, userName: item.name, role_icon: "android", is_starter: item.is_starter });
        }
      })
    }
    //this.filterPlayerOnField();
  }


}
